import React from 'react';
import { Loader2 } from 'lucide-react';
import './ControlPanel.css';

/**
 * ControlPanel
 * Standardized container for tool settings.
 * @param {string} title - Section title (e.g. "Settings")
 * @param {boolean} isLoading - Shows spinner on button
 * @param {boolean} disabled - Disables button
 * @param {string} actionLabel - Button text (e.g. "Remove Background")
 * @param {function} onAction - Click handler
 * @param {ReactNode} children - The specific sliders/toggles for the tool
 */
const ControlPanel = ({ 
    title = "Configuration", 
    isLoading, 
    disabled, 
    actionLabel, 
    onAction, 
    children 
}) => {
    return (
        <div className="control-panel fade-in">
            {/* 1. SETTINGS AREA */}
            <div className="panel-section">
                <h3 className="panel-label">{title}</h3>
                <div className="settings-grid">
                    {children}
                </div>
            </div>

            {/* 2. PRIMARY ACTION BUTTON */}
            {actionLabel && (
                <div className="panel-footer">
                    <button 
                        className="btn-primary-tool"
                        onClick={onAction}
                        disabled={disabled || isLoading}
                    >
                        {isLoading ? (
                            <>
                                <Loader2 size={18} className="spin" />
                                <span>Processing...</span>
                            </>
                        ) : (
                            <span>{actionLabel}</span>
                        )}
                    </button>
                </div>
            )}
        </div>
    );
};

export default ControlPanel;